import {
  Backdrop,
  Button,
  Container,
  Select,
  InputLabel,
  Fade,
  FormControl,
  Grid,
  // Modal,
  Paper,
  Snackbar,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  FormControlLabel,
} from "@material-ui/core";
import "../../App.css";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  // Table,
  Row,
  Col,
  UncontrolledAlert,
  Pagination,
  PaginationItem,
  PaginationLink,
  FormGroup,
} from "reactstrap";

import Modal from "react-awesome-modal";
import renderHTML from "react-render-html";
import { Link } from "react-router-dom";
import axios from "axios";
import React, { Component } from "react";
import Constants from "../Variables/Constants";
import init from "../../helpers/WindowToken";
import { lastPageRecordCount } from "./Components/PaginationTool";
import "../../App.css";

export default class whoWeAre extends Component {
  state = {
    allWhoWeAre: [],
    search: "",
    description: "",
    image: "",
    created_by: "",
    name: "",

    limit: 10,
    page: 1,
    nextPage: null,
    prevPage: null,
    totalDocs: 0,
    totalPages: 1,

    rowId: "",
    visible: false,
    loading: false,
    notifyDelete: false,
    delMsg: "",
    delLoading: false,
  };

  componentDidMount() {
    this.getWhoWeAre();
  }

  getWhoWeAre = () => {
    //   if ( init() === "success" ){
    axios
      .get(
        Constants.getUrls.getAllWhoWeAre +
          `?limit=${this.state.limit}` +
          `&page=${this.state.page}`
      )

      .then((resp) => {
        console.log(resp);
        this.setState(
          {
            allWhoWeAre: resp.data.data.docs,
            limit: resp.data.data.limit,
            nextPage: resp.data.data.nextPage,
            page: resp.data.data.page,
            prevPage: resp.data.data.prevPage,
            totalDocs: resp.data.data.totalDocs,
            totalPages: resp.data.data.totalPages,
            // loading: true
          },
          () => {
            console.log(this.state.allWhoWeAre);
          }
        );
      });
    //   }
  };

  handleSelect = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        if (init() === "success") {
          axios
            .get(
              Constants.getUrls.getAllWhoWeAre +
                `?limit=${this.state.limit}` +
                `&page=${1}`
            )
            .then((resp) => {
              console.log(resp);
              this.setState({
                allWhoWeAre: resp.data.data.docs,
                limit: resp.data.data.limit,
                nextPage: resp.data.data.nextPage,
                page: resp.data.data.page,
                prevPage: resp.data.data.prevPage,
                totalDocs: resp.data.data.totalDocs,
                totalPages: resp.data.data.totalPages,
              });
            });
        }
      }
    );
  };

  handleNext = () => {
    if (init() === "success") {
      axios
        .get(
          Constants.getUrls.getAllWhoWeAre +
            `?limit=${this.state.limit}` +
            `&page=${this.state.page + 1}`
        )

        .then((resp) => {
          console.log(this.state.allWhoWeAre, this.state.page);
          this.setState({
            allWhoWeAre: resp.data.data.docs,
            limit: resp.data.data.limit,
            nextPage: resp.data.data.nextPage,
            page: resp.data.data.page,
            prevPage: resp.data.data.prevPage,
            totalDocs: resp.data.data.totalDocs,
            totalPages: resp.data.data.totalPages,
          });
        });
    }
  };

  handlePrev = () => {
    if (this.state.page > 1) {
      if (init() === "success") {
        axios
          .get(
            Constants.getUrls.getAllWhoWeAre +
              `?limit=${this.state.limit}` +
              `&page=${this.state.page - 1}`
          )

          .then((resp) => {
            console.log(resp);
            this.setState({
              allWhoWeAre: resp.data.data.docs,
              limit: resp.data.data.limit,
              nextPage: resp.data.data.nextPage,
              page: resp.data.data.page,
              prevPage: resp.data.data.prevPage,
              totalDocs: resp.data.data.totalDocs,
              totalPages: resp.data.data.totalPages,
            });
          });
      }
    }
  };

  handleChange = (event, value) => {
    this.setState(
      {
        page: value,
      },
      () => {
        this.getWhoWeAre();
      }
    );
  };
  // search ends

  //   delete starts

  handleModal = (whoweare) => {
    this.setState({
      rowId: whoweare._id,
      visible: true,
    });
  };

  handleDelete = () => {
    this.setState({
      delLoading: true,
    });
    let payload = {
      _id: this.state.rowId,
    };

    if (init() == "success") {
      // this.setState({ delLoading: true });
      axios
        .delete(Constants.postUrls.deleteWhoWeAre + this.state.rowId)
        .then((res) => {
          console.log(res);
          this.setState({
            deleteWhoWeAre: true,
            delLoading: false,
            delMsg: res.data.message,
          });
          setTimeout(() => {
            this.setState({ deleteWhoWeAre: false, visible: false }, () => {
              this.getWhoWeAre();
            });
          }, 2000);
        });
    }
  };

  render() {
    return (
      <Container maxWidth="xl">
        <Grid container spcaing={2}>
          <Grid item sm={6}>
            <Typography variant="h4">Who We Are</Typography>
          </Grid>
          <Grid container justify="flex-end">
            {/* <FormControl >
                              <TextField
                                  id="standard-basic"
                                  label="Search Testimonial"
                                  variant="standard"
                                  size="small"
                                  name="search"
                                  onChange={this.handleChange}
                                  />
                          </FormControl> */}

            {/* <Link
              to="/admin/addwhoweare"
              style={{ textDecoration: "none", marginBottom: "1rem" }}
            >
              <Button
                color="primary"
                variant="contained"
                size="medium"
                onClick={() => {
                  this.setState({ open: true });
                }}
              >
                Add Who We Are
              </Button>
            </Link> */}
          </Grid>
        </Grid>

        <Grid sm={12}>
          <Paper elevetion={1}>
            <TableContainer>
              <Table size="small" stickyHeader aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <TableCell>S.No</TableCell>
                    <TableCell>Description</TableCell>

                    <TableCell>Images</TableCell>
                    <TableCell align="center">Action</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {this.state.allWhoWeAre?.length > 0 ? (
                    this.state.allWhoWeAre.map((whoweare, index) => (
                      <TableRow>
                        <TableCell>
                          {" "}
                          {Number((this.state.page - 1) * this.state.limit) +
                            Number(index + 1)}{" "}
                        </TableCell>

                        <TableCell>
                          {" "}
                          {renderHTML(whoweare.description)}{" "}
                        </TableCell>

                        <TableCell>
                          <img
                            src={
                              Constants.imgDomain.imgMainDomain +
                              `${whoweare?.image}`
                            }
                            alt="pic"
                            width="100vw"
                            height="100vh"
                          />
                        </TableCell>

                        <TableCell align="center">
                          <Link
                            to={{
                              pathname: "/admin/updatewhoweare/" + whoweare._id,
                              state: { data: whoweare },
                            }}
                            style={{ textDecoration: "none" }}
                          >
                            <Button
                              variant={"outlined"}
                              color="default"
                              style={{ marginRight: 4 }}
                              size={"small"}
                            >
                              Update
                            </Button>
                          </Link>
                          {/* <Button
                            size={"small"}
                            variant={"outlined"}
                            color="secondary"
                            onClick={() => {
                              this.handleModal(whoweare);
                            }}
                          >
                            Delete
                          </Button> */}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell>NO DATA FOUND</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>

              <TableRow
                style={{ display: "flex", justifyContent: "space-around" }}
              >
                <div>
                  <p>
                    Showing{" "}
                    {Number((this.state.page - 1) * this.state.limit) + 1} to{" "}
                    {lastPageRecordCount(
                      this.state.totalDocs,
                      this.state.page,
                      this.state.limit
                    )}{" "}
                    of {this.state.totalDocs} Entries
                  </p>
                </div>

                {/* Rows PerPage START */}

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "200px",
                  }}
                >
                  <p>Rows Per Page</p>

                  <FormControl
                    className="selectMerchants"
                    style={{ marginRight: "20px", marginTop: "-12px" }}
                  >
                    <InputLabel htmlFor="age-native-simple"></InputLabel>
                    <Select
                      native
                      value={this.state.limit}
                      onChange={this.handleSelect}
                      inputProps={{
                        name: "limit",
                        id: "age-native-simple",
                      }}
                    >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </Select>
                  </FormControl>
                </div>

                {/* Rows PerPage END */}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginLeft: "290px",
                  }}
                >
                  <Button
                    variant="contained"
                    color="secondary"
                    className="mx-5"
                    style={{ margin: "10px" }}
                    disabled={this.state.prevPage === null}
                    onClick={this.handlePrev}
                    // Hidden
                  >
                    Previous
                  </Button>{" "}
                  <Pagination
                    count={this.state.totalPages}
                    shape="rounded"
                    page={this.state.page}
                    onChange={this.handleChange}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    className="mx-5"
                    disabled={this.state.nextPage === null}
                    style={{ margin: "10px" }}
                    onClick={this.handleNext}
                  >
                    Next
                  </Button>
                </div>
              </TableRow>
            </TableContainer>
          </Paper>
        </Grid>
        <Modal
          visible={this.state.visible}
          onClickAway={() => this.setState({ visible: false })}
          width="450px"
          height="80px"
          effect="fadeInUp"
        >
          <Row>
            <Col xs={12} xm={12} md={12}>
              <Card>
                <CardBody>
                  <div className="modal">
                    <h3 classname="changeColor" style={{ color: "black" }}>
                      {" "}
                      Are you sure you want to Delete??
                    </h3>

                    {this.state.deleteWhoWeAre ? (
                      <Snackbar
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "bottom",
                        }}
                        open={true}
                        autoHideDuration={5000}
                        color={"s"}
                        message="deleted Successfully"
                      ></Snackbar>
                    ) : null}

                    <Row>
                      <Col xs={12} xm={12} md={4}>
                        <br />
                        <Button
                          className=""
                          color="secondary"
                          variant="contained"
                          style={{ margin: "20px" }}
                          onClick={() => {
                            this.handleDelete(this.state.rowId);
                          }}
                        >
                          {this.state.deleteWhoWeAre ? "Deleting....." : "Yes"}
                        </Button>
                        <Button
                          className=""
                          variant="contained"
                          color="primary"
                          style={{ margin: "20px", marginLeft: "4px" }}
                          onClick={() => {
                            this.setState({ visible: false });
                          }}
                        >
                          no
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Modal>
      </Container>
    );
  }
}
